import React, { useState } from "react";
import { useTranslation } from 'react-i18next';

const CopyButton = ({ textToCopy, className = "", children }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(textToCopy);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      onClick={handleCopy}
      className={`absolute top-2 right-2 text-sm bg-white border px-2 py-1 rounded hover:bg-gray-100 transition-all ${className}`}
      title={t('copyButton.tooltip')}
    >
      {copied ? t('copyButton.copied') : children || t('copyButton.copy')}
    </button>
  );
};

export default CopyButton;